"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetServiceStatWithExtras = exports.useGetFullServiceStatsForCompany = exports.useGetFullServiceStatsForProfile = void 0;
var react_redux_1 = require("react-redux");
var populated_1 = require("../selectors/populated");
var populatedDerived_1 = require("../selectors/populatedDerived");
var single_1 = require("../selectors/single");
var useOwnersFilter_1 = __importDefault(require("./useOwnersFilter"));
var useGetFullServiceStatsForProfile = function (unfiltered) {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    if (!profile.companyId) {
        throw new Error('User without companyId');
    }
    return (0, exports.useGetFullServiceStatsForCompany)(profile.companyId, unfiltered);
};
exports.useGetFullServiceStatsForProfile = useGetFullServiceStatsForProfile;
var useGetFullServiceStatsForCompany = function (companyId, unfiltered) {
    var serviceStatsArray = (0, react_redux_1.useSelector)(unfiltered
        ? populated_1.selectUnfilteredPopulatedServiceStats
        : populatedDerived_1.selectPopulatedServiceStats);
    var _a = __read((0, useOwnersFilter_1.default)(serviceStatsArray), 2), serviceStatsFilteredByOwners = _a[0], setOwnersToFilterBy = _a[1];
    // ToDo: figure out why useMemo barely works here tempSolution: use rating sum as memo parameter
    // ToDo: Also, handle all the necessary TS to filter after adding extra data
    return [serviceStatsFilteredByOwners, setOwnersToFilterBy];
};
exports.useGetFullServiceStatsForCompany = useGetFullServiceStatsForCompany;
var useGetServiceStatWithExtras = function (idForService, unfiltered) {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    if (!profile.companyId) {
        throw new Error('User without companyId');
    }
    var _a = __read((0, exports.useGetFullServiceStatsForCompany)(profile.companyId, unfiltered), 2), calculatedServiceStatsData = _a[0], setOwnersToFilterBy = _a[1];
    var serviceStat = calculatedServiceStatsData === null || calculatedServiceStatsData === void 0 ? void 0 : calculatedServiceStatsData.find(function (_a) {
        var serviceId = _a.serviceId;
        return serviceId === idForService;
    });
    return [serviceStat, setOwnersToFilterBy];
};
exports.useGetServiceStatWithExtras = useGetServiceStatWithExtras;
